import React, { useState } from 'react';
import { Users, Target, Heart, Leaf, Home, TrendingUp, Calendar, ArrowRight } from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBullseye,
  faEye,
  faScaleBalanced,
  faChartLine,
  faClockRotateLeft,
  faCrosshairs,
  faBolt,
  faRobot
} from '@fortawesome/free-solid-svg-icons';



const Company = () => {
  const [selectedTimelineItem, setSelectedTimelineItem] = useState(0);

  const timeline = [
    { 
      year: '2000', 
      title: 'Company Founded', 
      description: 'Sterling Surveillance Technologies LTD was established with a vision to revolutionize security through technology. Starting with traditional security services, we quickly recognized the potential of remote monitoring and AI-powered solutions to transform the industry.' 
    },
    { 
      year: '2005', 
      title: 'First Major Contract', 
      description: 'Secured our first large-scale commercial monitoring contract with a Fortune 500 company, setting the foundation for growth. This milestone demonstrated our ability to handle complex security requirements and established our reputation in the industry.' 
    },
    { 
      year: '2010', 
      title: 'AI Integration', 
      description: 'Pioneered the integration of AI-powered surveillance systems in the security industry. Our proprietary algorithms began learning from patterns, reducing false alarms by 85% and improving response times significantly.' 
    },
    { 
      year: '2015', 
      title: 'Remote Solutions', 
      description: 'Launched comprehensive remote access management and concierge services. This expansion allowed us to serve clients across multiple time zones with 24/7 coverage, revolutionizing how security services are delivered.' 
    },
    { 
      year: '2020', 
      title: 'Digital Transformation', 
      description: 'Fully transitioned to cloud-based monitoring with 24/7 real-time response capabilities. The pandemic accelerated demand for contactless security solutions, positioning us as an industry leader in remote monitoring technology.' 
    },
    { 
      year: '2025', 
      title: 'Industry Leader', 
      description: 'Recognized as the leading provider of intelligent remote security solutions nationwide. Our AI systems now protect over 10,000 properties across North America, with 99.9% uptime and industry-leading customer satisfaction ratings.' 
    }
  ];

  const styles = {
    root: {
      '--primary-dark': '#010A1A',
      '--secondary-dark': '#002C58',
      '--text-primary': '#ffffff',
      '--text-secondary': '#94a3b8',
      '--box-dark-bg': '#1a2332',
      '--icons-color': '#155EEF',
      '--accent-cyan': '#06b6d4',
      '--accent-blue': '#3b82f6'
    }
  };

  return (
    <div className="min-vh-100" 
         style={{
           backgroundColor: 'var(--primary-dark)',
           color: 'var(--text-primary)',
           fontFamily: 'system-ui, -apple-system, sans-serif',
           ...styles.root
         }}>

      {/* Hero Section */}
      <section className="general-banner">
          <div className="container">
            <div className="general-content">
              <h1 className="hero-title orbitron">Company</h1>
              {/* <p className="hero-subtitle">Creating a legacy of commercial and residential properties along with significant public benefits</p> */}
            </div>
          </div>
        </section>

      {/* Company Description */}
      <section className="py-5" style={{ backgroundColor: 'var(--box-dark-bg)' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="text-center mb-5">
                <h2 className="display-5 fw-bold mb-4" style={{ color: 'var(--text-primary)' }}>
                  Sterling Surveillance Technologies LTD
                </h2>
                <div style={{ color: 'var(--text-secondary)', fontSize: '1.1rem', lineHeight: '1.8' }}>
                    {/* <p className="mb-4">
              At Sterling Surveillance Technologies, we deliver advanced, technology-driven security solutions designed to meet the evolving needs of modern businesses and communities across Canada. Backed by years of industry experience, our team of highly trained security professionals and industry specialists are committed to providing proactive, reliable, and responsive protection 24 hours a day, 7 days a week.

</p>

           
            <p className="mb-4">
            Utilizing cutting-edge AI-powered surveillance systems, real-time monitoring, and strategic on-site and mobile patrol services, we ensure the highest standard of safety and operational excellence for every client. Our tailored approach allows us to safeguard a wide range of environments—including residential developments, commercial properties, and active construction sites—with precision and accountability.

            </p>
<p className="mb-0">
            We are not just a security provider—we are a trusted partner in protection, risk mitigation, and peace of mind.
            </p> */}
            {/* is a Canadian-owned and operated security services provider, founded in Alberta in 2014 with a clear purpose: to set new benchmarks in safety, reliability, and innovation within the private security sector.

Over the years, we have evolved from a regional service provider to a trusted national partner. In 2019, we expanded our operations to British Columbia, and by 2023, we had established a strong presence in Ontario. Today, we operate across multiple provinces, offering a full suite of integrated security solutions tailored to meet the unique requirements of diverse industries, sites, and environments.

Our approach combines industry-certified professionals, proven operational systems, and cutting-edge AI surveillance technologies to deliver proactive, data-driven security. We serve a broad portfolio of clients, including residential developers, construction firms, commercial property managers, and institutional organizations—providing 24/7 on-site security, mobile patrols, video analytics, and remote monitoring services.

At the core of our business is an uncompromising commitment to professionalism, accountability, and continuous improvement. Whether securing a single asset or managing multi-site operations, we deliver measurable value, peace of mind, and long-term partnership. */}
                  <p className="mb-4">
                    Over the years, we have evolved from a regional service provider to a trusted national partner. In 2019, we expanded our operations to British Columbia, and by 2023, we had established a strong presence in Ontario. Today, we operate across multiple provinces, offering a full suite of integrated security solutions tailored to meet the unique requirements of diverse industries, sites, and environments.
 </p>
                  <p className="mb-4">
                    Utilizing cutting-edge AI-powered surveillance systems, real-time monitoring, and strategic on-site and mobile patrol services, we ensure the highest standard of safety and operational excellence for every client. Our tailored approach allows us to safeguard a wide range of environments—including residential developments, commercial properties, and active construction sites—with precision and accountability.
                  We are not just a security provider—we are a trusted partner in protection, risk mitigation, and peace of mind.
                  </p>
                  <p className='mb-4'>
                    Our approach combines industry-certified professionals, proven operational systems, and cutting-edge AI surveillance technologies to deliver proactive, data-driven security. We serve a broad portfolio of clients, including residential developers, construction firms, commercial property managers, and institutional organizations—providing 24/7 on-site security, mobile patrols, video analytics, and remote monitoring services.

                  </p>
                  {/* <p className="mb-0">
                    Sterling Protection Services serves our clients with a deep understanding of their unique security challenges. 
                    From construction sites to residential complexes, we deliver tailored remote security solutions that provide 
                    peace of mind and operational efficiency.
                  </p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

{/* Mission, Vision, Values */}
        <section className="py-5" style={{ backgroundColor: 'var(--secondary-dark)' }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-4 mb-4">
                <div 
                  className="h-100 p-4 rounded-3 text-center service-card"
                  style={{ backgroundColor: 'var(--box-dark-bg)' }}
                >
                  <div 
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                    style={{ 
                      width: '60px', 
                      height: '60px', 
                      color: 'var(--icons-color)',
                      fontSize: '3rem'
                    }}
                  >
                    <FontAwesomeIcon icon={faBullseye} />
                  </div>
                  <h3 className="orbitron mb-3" style={{ color: 'var(--text-primary)' }}>Our Mission</h3>
                  <p style={{ color: 'var(--text-secondary)' }}>
                    To deliver trusted, technology-driven security and surveillance solutions that safeguard people, property, and operations. We are committed to providing responsive, reliable, and professional service through a team that is trained, accountable, and driven by purpose.
</p>
                  <div className="triangle-bottomright-blue"></div>
                </div>
              </div>
              <div className="col-lg-4 mb-4">
                <div 
                  className="h-100 p-4 rounded-3 text-center service-card"
                  style={{ backgroundColor: 'var(--box-dark-bg)' }}
                >
                  <div 
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                    style={{ 
                      width: '60px', 
                      height: '60px', 
                      color: 'var(--icons-color)',
                      fontSize: '3rem'
                    }}
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </div>
                  <h3 className="orbitron mb-3" style={{ color: 'var(--text-primary)' }}>Our Vision</h3>
                  <p style={{ color: 'var(--text-secondary)' }}>
                    To be Canada’s leading provider of integrated security services, recognized for our commitment to innovation, excellence, and trusted partnerships.
                  </p>
                  <div className="triangle-bottomright-blue"></div>
                </div>
              </div>
              <div className="col-lg-4 mb-4">
                <div 
                  className="h-100 p-4 rounded-3 text-center service-card"
                  style={{ backgroundColor: 'var(--box-dark-bg)' }}
                >
                  <div 
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                    style={{ 
                      width: '60px', 
                      height: '60px', 
                      color: 'var(--icons-color)',
                      fontSize: '3rem'
                    }}
                  >
                    <FontAwesomeIcon icon={faScaleBalanced} />
                  </div>
                  <h3 className="orbitron mb-3" style={{ color: 'var(--text-primary)' }}>Our Values</h3>
                  <p style={{ color: 'var(--text-secondary)' }}>
                    We adhere to the highest ethical and professional standards. Our clients entrust us with critical responsibilities involving people, assets, and reputations.
                  </p>
                  <div className="triangle-bottomright-blue"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      {/* Core Values Header */}
      <section className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="display-5 fw-bold" style={{ color: 'var(--text-primary)' }}>
                Our core values
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8 mx-auto text-center">
              <p style={{ color: 'var(--text-secondary)', fontSize: '1.1rem', lineHeight: '1.7' }}>
                Our value lies in how we protect what matters most: people, property, and peace of mind. We achieve this by integrating expertise from a wide range of disciplines including security operations, surveillance technology, site management, logistics, client relations, and risk assessment.

              </p>
              <p style={{ color: 'var(--text-secondary)', fontSize: '1.1rem', lineHeight: '1.7' }}>
                With a foundation built on trust, leadership, and real-world experience, we operate under a clear set of core values that guide every action we take. These values reflect not only our company’s mission but also the personal journey and hands-on commitment of our leadership, built from the ground up, shaped through field experience, and driven by a dedication to quality, reliability, and long-term growth.

              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Respect for Community */}
      <section className="py-5" style={{ backgroundColor: 'var(--box-dark-bg)' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="pe-lg-4">
                <div className="d-flex align-items-center mb-3">
                  <div className="p-2 rounded-2 me-3" style={{ backgroundColor: 'var(--icons-color)' }}>
                    <Users className="w-5 h-5" style={{ color: 'white' }} />
                  </div>
                  <h3 className="fw-bold mb-0" style={{ color: 'var(--accent-cyan)' }}>
                    Integrity
                  </h3>
                </div>
                <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                  <p className="mb-3">
                    We adhere to the highest ethical and professional standards. Our clients entrust us with critical responsibilities involving people, assets, and reputations. We honour that trust through transparency, accountability, and principled action at every level of our organization.
                  </p>
                  <p className="mb-3">
                    Our technology-driven approach recognizes that our activities can affect our habitat, 
                    both socially and economically. We strive to make positive contributions to community 
                    safety while minimizing any negative impacts through responsible implementation.
                  </p>
                  <p className="mb-0">
                    We believe a building should be respectful of the community. Protection of the 
                    environment must be foremost in our long term thinking.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <img 
                src="../images/Integrity.jpg" 
                alt="Community residential development" 
                className="img-fluid rounded-3 shadow-lg"
                style={{ width: '100%', height: '350px', objectFit: 'cover' }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Respect for Land and Environment */}
      <section className="py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 order-lg-2 mb-4 mb-lg-0">
              <div className="ps-lg-4">
                <div className="d-flex align-items-center mb-3">
                  <div className="p-2 rounded-2 me-3" style={{ backgroundColor: 'var(--icons-color)' }}>
                    <Leaf className="w-5 h-5" style={{ color: 'white' }} />
                  </div>
                  <h3 className="fw-bold mb-0" style={{ color: 'var(--accent-cyan)' }}>
                    Reliability
                  </h3>
                </div>
                <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                  <p className="mb-3">
                    Security is only effective when it is consistent. We are committed to dependable service delivery—24 hours a day, 7 days a week—supported by real-time response protocols, centralized communication, and a culture of operational discipline.
                  </p>
                  <p className="mb-3">
                    Through energy-efficient monitoring systems and minimal physical infrastructure, 
                    we reduce our environmental footprint while providing maximum security coverage.
                  </p>
                  <p className="mb-0">
                    <em>Green from the ground up. Preserved is historical details. Award Winning.</em>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 order-lg-1">
              <img 
                src="../images/Reliability.jpg" alt="Sustainable waterfront development" 
                className="img-fluid rounded-3 shadow-lg"
                style={{ width: '100%', height: '350px', objectFit: 'cover' }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Commitment to Home Ownership */}
      <section className="py-5" style={{ backgroundColor: 'var(--box-dark-bg)' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="pe-lg-4">
                <div className="d-flex align-items-center mb-3">
                  <div className="p-2 rounded-2 me-3" style={{ backgroundColor: 'var(--icons-color)' }}>
                    <Home className="w-5 h-5" style={{ color: 'white' }} />
                  </div>
                  <h3 className="fw-bold mb-0" style={{ color: 'var(--accent-cyan)' }}>
                    Innovation
                  </h3>
                </div>
                <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                  <p className="mb-3">
                   We are not static. We invest in advanced AI-driven technologies and intelligent systems that allow us to detect, deter, and respond to threats with precision. Our focus on innovation ensures we remain agile in a fast-evolving security landscape.
                  </p>
                  <p className="mb-0">
                    Through innovative remote monitoring and access control systems, we help 
                    property owners maintain and increase their investment value while ensuring 
                    the safety of their communities.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <img 
                src="../images/Innovtion.jpg"  alt="Modern home interior" 
                className="img-fluid rounded-3 shadow-lg"
                style={{ width: '100%', height: '350px', objectFit: 'cover' }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Planning for the Future */}
      <section className="py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 order-lg-2 mb-4 mb-lg-0">
              <div className="ps-lg-4">
                <div className="d-flex align-items-center mb-3">
                  <div className="p-2 rounded-2 me-3" style={{ backgroundColor: 'var(--icons-color)' }}>
                    <TrendingUp className="w-5 h-5" style={{ color: 'white' }} />
                  </div>
                  <h3 className="fw-bold mb-0" style={{ color: 'var(--accent-cyan)' }}>
                    Professional Excellence
                  </h3>
                </div>
                <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                  <p className="mb-3">
                    We set high standards for recruitment, training, and performance. Our licensed personnel undergo continuous professional development to ensure they are equipped with the skills, knowledge, and conduct expected in critical roles.
                  </p>
                  <p className="mb-0">
                    Through continuous innovation and strategic partnerships, we ensure our 
                    security solutions remain at the forefront of technology while providing 
                    sustainable, long-term value for our clients.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 order-lg-1">
              <img 
                src="../images/Professional Excellence.jpg"    alt="Modern office building" 
                className="img-fluid rounded-3 shadow-lg"
                style={{ width: '100%', height: '350px', objectFit: 'cover' }}
              />
            </div>
          </div>
        </div>
      </section>

            <section className="py-5" style={{ backgroundColor: 'var(--box-dark-bg)' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="pe-lg-4">
                <div className="d-flex align-items-center mb-3">
                  <div className="p-2 rounded-2 me-3" style={{ backgroundColor: 'var(--icons-color)' }}>
                    <Home className="w-5 h-5" style={{ color: 'white' }} />
                  </div>
                  <h3 className="fw-bold mb-0" style={{ color: 'var(--accent-cyan)' }}>
                    Client-Centric Service
                  </h3>
                </div>
                <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                  <p className="mb-3">
                  Every site and client is unique. We take a tailored approach to security planning and execution, aligning our solutions with client objectives, site risks, and long-term operational goals.</p>
                
                  <p className="mb-0">
                    Through innovative remote monitoring and access control systems, we help 
                    property owners maintain and increase their investment value while ensuring 
                    the safety of their communities.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <img 
                src="../images/Client-Focused Approach.jpg"   alt="Modern home interior" 
                className="img-fluid rounded-3 shadow-lg"
                style={{ width: '100%', height: '350px', objectFit: 'cover' }}
              />
            </div>
          </div>
        </div>
      </section>


      <section className="py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 order-lg-2 mb-4 mb-lg-0">
              <div className="ps-lg-4">
                <div className="d-flex align-items-center mb-3">
                  <div className="p-2 rounded-2 me-3" style={{ backgroundColor: 'var(--icons-color)' }}>
                    <TrendingUp className="w-5 h-5" style={{ color: 'white' }} />
                  </div>
                  <h3 className="fw-bold mb-0" style={{ color: 'var(--accent-cyan)' }}>
                    Collaboration
                  </h3>
                </div>
                <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                  <p className="mb-3">
                    We believe in the power of strong partnerships. Internally and externally, we foster a culture of teamwork, open communication, and shared accountability—ensuring alignment between all stakeholders, from field operations to executive management.</p>
                  <p className="mb-0">
                    Through continuous innovation and strategic partnerships, we ensure our 
                    security solutions remain at the forefront of technology while providing 
                    sustainable, long-term value for our clients.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 order-lg-1">
              <img 
                src="../images/Collaboration.jpg" alt="Modern office building" 
                className="img-fluid rounded-3 shadow-lg"
                style={{ width: '100%', height: '350px', objectFit: 'cover' }}
              />
            </div>
          </div>
        </div>
      </section>


    

      {/* Interactive Company Timeline */}
      <section className="py-5 interactive-timeline" style={{ backgroundColor: 'var(--box-dark-bg)' }}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="display-5 fw-bold" style={{ color: 'var(--text-primary)' }}>
                Our Journey
              </h2>
              <p className="lead" style={{ color: 'var(--text-secondary)' }}>
                10+ years of innovation in security solutions
              </p>
            </div>
          </div>
          
          {/* Interactive Timeline */}
          <div className="row">
            <div className="col-12">
              {/* Timeline Navigation */}
              <div className="position-relative mb-5">
                {/* Timeline Line */}
                <div 
                  className="position-absolute w-100" 
                  style={{
                    height: '4px',
                    backgroundColor: 'var(--secondary-dark)',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    borderRadius: '2px'
                  }}
                ></div>
                
                {/* Timeline Progress */}
                <div 
                  className="position-absolute" 
                  style={{
                    height: '4px',
                    backgroundColor: 'var(--accent-cyan)',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    borderRadius: '2px',
                    width: `${(selectedTimelineItem / (timeline.length - 1)) * 100}%`,
                    transition: 'width 0.3s ease'
                  }}
                ></div>
                
                {/* Timeline Points */}
                <div className="d-flex justify-content-between position-relative">
                  {timeline.map((item, index) => (
                    <button
                      key={index}
                      onClick={() => setSelectedTimelineItem(index)}
                      className={`btn p-0 d-flex flex-column align-items-center position-relative ${
                        index === selectedTimelineItem ? 'active' : ''
                      }`}
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease'
                      }}
                    >
                      {/* Timeline Dot */}
                      <div 
                        className="rounded-circle mb-3 d-flex align-items-center justify-content-center"
                        style={{
                          width: index === selectedTimelineItem ? '24px' : '16px',
                          height: index === selectedTimelineItem ? '24px' : '16px',
                          backgroundColor: index === selectedTimelineItem ? 'var(--accent-cyan)' : 'var(--icons-color)',
                          transition: 'all 0.3s ease',
                          boxShadow: index === selectedTimelineItem ? '0 0 20px rgba(6, 182, 212, 0.5)' : 'none',
                          transform: index === selectedTimelineItem ? 'scale(1.2)' : 'scale(1)'
                        }}
                      ></div>
                      
                      {/* Year Label */}
                      <div 
                        className="fw-bold text-center"
                        style={{
                          color: index === selectedTimelineItem ? 'var(--accent-cyan)' : 'var(--text-secondary)',
                          fontSize: index === selectedTimelineItem ? '1.1rem' : '0.95rem',
                          transition: 'all 0.3s ease',
                          minWidth: '60px'
                        }}
                      >
                        {item.year}
                      </div>
                    </button>
                  ))}
                </div>
              </div>
              
              {/* Timeline Content */}
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div 
                    className="p-5 rounded-4 text-center"
                    style={{
                      backgroundColor: 'var(--primary-dark)',
                      border: '1px solid var(--secondary-dark)',
                      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
                      transition: 'all 0.5s ease'
                    }}
                  >
                    <div 
                      className="fw-bold mb-3"
                      style={{
                        color: 'var(--accent-cyan)',
                        fontSize: '3.5rem',
                        fontWeight: '800',
                        textShadow: '0 0 30px rgba(6, 182, 212, 0.3)'
                      }}
                    >
                      {timeline[selectedTimelineItem].year}
                    </div>
                    
                    <h3 
                      className="fw-bold mb-4"
                      style={{
                        color: 'var(--text-primary)',
                        fontSize: '1.8rem'
                      }}
                    >
                      {timeline[selectedTimelineItem].title}
                    </h3>
                    
                    <p 
                      style={{
                        color: 'var(--text-secondary)',
                        lineHeight: '1.8',
                        fontSize: '1.1rem',
                        maxWidth: '600px',
                        margin: '0 auto'
                      }}
                    >
                      {timeline[selectedTimelineItem].description}
                    </p>
                    
                    {/* Navigation Arrows */}
                    <div className="d-flex justify-content-center gap-3 mt-4">
                      <button
                        onClick={() => setSelectedTimelineItem(Math.max(0, selectedTimelineItem - 1))}
                        disabled={selectedTimelineItem === 0}
                        className="btn d-flex align-items-center justify-content-center"
                        style={{
                          width: '50px',
                          height: '50px',
                          backgroundColor: selectedTimelineItem === 0 ? 'var(--secondary-dark)' : 'var(--icons-color)',
                          border: 'none',
                          borderRadius: '50%',
                          cursor: selectedTimelineItem === 0 ? 'not-allowed' : 'pointer',
                          opacity: selectedTimelineItem === 0 ? 0.5 : 1,
                          transition: 'all 0.3s ease'
                        }}
                      >
                        <ArrowRight 
                          className="w-5 h-5" 
                          style={{ 
                            color: 'white', 
                            transform: 'rotate(180deg)' 
                          }} 
                        />
                      </button>
                      
                      <button
                        onClick={() => setSelectedTimelineItem(Math.min(timeline.length - 1, selectedTimelineItem + 1))}
                        disabled={selectedTimelineItem === timeline.length - 1}
                        className="btn d-flex align-items-center justify-content-center"
                        style={{
                          width: '50px',
                          height: '50px',
                          backgroundColor: selectedTimelineItem === timeline.length - 1 ? 'var(--secondary-dark)' : 'var(--icons-color)',
                          border: 'none',
                          borderRadius: '50%',
                          cursor: selectedTimelineItem === timeline.length - 1 ? 'not-allowed' : 'pointer',
                          opacity: selectedTimelineItem === timeline.length - 1 ? 0.5 : 1,
                          transition: 'all 0.3s ease'
                        }}
                      >
                        <ArrowRight className="w-5 h-5" style={{ color: 'white' }} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Timeline Statistics */}
              {/* <div className="row mt-5">
                <div className="col-12">
                  <div className="row text-center">
                    <div className="col-md-3 mb-3">
                      <div className="fw-bold display-6" style={{ color: 'var(--accent-cyan)' }}>25+</div>
                      <div style={{ color: 'var(--text-secondary)' }}>Years of Experience</div>
                    </div>
                    <div className="col-md-3 mb-3">
                      <div className="fw-bold display-6" style={{ color: 'var(--accent-cyan)' }}>10K+</div>
                      <div style={{ color: 'var(--text-secondary)' }}>Properties Secured</div>
                    </div>
                    <div className="col-md-3 mb-3">
                      <div className="fw-bold display-6" style={{ color: 'var(--accent-cyan)' }}>99.9%</div>
                      <div style={{ color: 'var(--text-secondary)' }}>Uptime Guarantee</div>
                    </div>
                    <div className="col-md-3 mb-3">
                      <div className="fw-bold display-6" style={{ color: 'var(--accent-cyan)' }}>24/7</div>
                      <div style={{ color: 'var(--text-secondary)' }}>Monitoring Service</div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {/* Company Summary */}
      {/* <section className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto text-center">
              <h2 className="display-5 fw-bold mb-4" style={{ color: 'var(--text-primary)' }}>
                Sterling Protection Services has been a valued customer of our bank for over 20 years.
              </h2>
              <p className="lead mb-4" style={{ color: 'var(--text-secondary)' }}>
                They have always lived up to their commitments and we consider them to be one of our 
                top-tier clients. They are financially sound and professionally capable.
              </p>
              <div className="mt-4">
                <p className="fw-bold mb-1" style={{ color: 'var(--accent-cyan)' }}>
                  KEITH MORRISON
                </p>
                <p style={{ color: 'var(--text-secondary)' }}>
                  Senior Vice President, Commercial Banking
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}


      {/* Footer CTA */}
      <section className="py-5" 
               style={{
                 background: `linear-gradient(135deg, var(--secondary-dark) 0%, var(--accent-blue) 100%)`
               }}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="display-5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                Ready to Secure Your Future?
              </h2>
              <p className="lead mb-4" style={{ color: 'var(--text-primary)' }}>
                Join the thousands of satisfied clients who trust Sterling Surveillance Technologies LTD Services
              </p>
              <button className="btn btn-light btn-lg px-4 py-2 d-flex align-items-center gap-2 mx-auto">
                <a className='anchorStyle' href="/services">Learn More About Our Services <ArrowRight className="w-4 h-4" /></a>
              </button>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Company;